import styled from 'styled-components';
import theme from '../../constants/theme';

export const TopbarSC = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99998;
  display: flex;
  height: 60px;
  background: #fff;
  box-shadow: ${({ theme }) => theme.shadows.low};
  padding-left: 16px;

  .provider-select {
    flex: 1;
    min-width: 200px;
    max-width: 436px;
  }

  .lang-switcher {
    min-width: 130px;
    margin-left: 60px;
  }

  .tb-logo {
    align-self: center;
  }

  > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;

export const TopbarUserSC = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: 16px;
  width: 260px;

  .tb-drop-wrapper {
    display: flex;
    align-items: center;
    padding: 0 16px;
    height: 60px;
    border-left: 1px solid #d6d8e2;
    cursor: pointer;
  }

  .tb-avatar-img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .tb-avatar {
    margin-left: 10px;
  }

  .tb-check {
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    right: 0;
    border-radius: 50%;
    background: ${theme.colors.accent};
  }
`;
